import { EventBus, Events } from '~/lib/events'
import useMetrics from '~/lib/hooks/use-metrics'

export default ({ $api, $sentry }) => {
  const api = useMetrics($api)

  EventBus.$on(Events.FileDownloaded, async ({ logo }) => {
    if (!logo || !logo.id) return
    await api
      .trackLogoFileDownloaded(logo)
      .catch(e => $sentry.captureException(e))
  })
}
